import * as React from "react";
import { observer } from "mobx-react";
import i18n from "i18n";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { CardTotal } from "./CardTotal";
import TableOccurences from "./TableOccurences";
import LoadingLayer from "./LoadingLayer";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSItemOccurrencesStore } from "modules/WBS/WBSItemOccurrencesStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { formatMonetary } from "utils/MathUtils";

const styles = (theme) => ({
  textContainer: { padding: "1rem 0", "& .text": { color: "#424242" } },
  cardContainer: {
    padding: "1rem 0",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
    width: "5rem !important",
    height: "5rem !important",
  },
});

/** Componente Janela modal que exibe as ocorrências de um insumo/composição
 * por toda EAP.
 */
@observer
class DialogItemOccurrences extends React.Component<{ classes: any }> {
  handleClose = () => {
    WBSItemOccurrencesStore.closeOccurences();
  };

  handleClickRowLink = (id: string) => {
    const row = WBSStore.findEAPRowById(id);
    if (row) {
      this.handleClose();

      const redirect = WBSItemOccurrencesStore.enableRedirectIfTaskIsOpen();
      setTimeout(
        () => {
          WBSStore.setSelectedLine(row.index || 0).catch((error) =>
            console.error("Error on select row on EAP", error)
          );
        },
        redirect ? 500 : 100
      );
    }
  };

  redirectToEAPPage = () => {
    const dev = DevelopmentStore.developmentSelected;
    if (dev) {
      return <Redirect to={`/${dev.id}/WBS`} />;
    }
    return <></>;
  };

  render() {
    const { classes } = this.props;
    const open = WBSItemOccurrencesStore.showOccurencesLayer;
    const loading = WBSItemOccurrencesStore.loading;

    const item = WBSItemOccurrencesStore.getItemData();
    const rows = WBSItemOccurrencesStore.getRows();

    if (WBSItemOccurrencesStore.redirectToEAP) {
      return this.redirectToEAPPage();
    }

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        data-testid="dialogModal-ItemOcurences"
        maxWidth="xl"
        fullWidth={false}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "#fff",
            width: "75vw",
            maxWidth: "1000px",
            height: "74vh",
            maxHeight: "568px",
          },
        }}
      >
        {loading && <LoadingLayer onCancel={this.handleClose} />}
        {!loading && (
          <>
            <DialogContent>
              <Typography variant="h6">
                {i18n.wbs.itemOccurrences.title}
              </Typography>
              <Grid container className={classes.textContainer}>
                <Grid item xs={2} lg={1}>
                  <Typography className="text">{item.code}</Typography>
                </Grid>
                <Grid item xs lg>
                  <Typography className="text">{item.description}</Typography>
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.cardContainer}
                alignItems="flex-start"
              >
                <Grid container item xs style={{ gap: "1.5rem" }}>
                  <CardTotal
                    label={i18n.wbs.itemOccurrences.fields.unit}
                    value={item.unit}
                  />
                  <CardTotal
                    label={i18n.wbs.itemOccurrences.equipment}
                    value={formatMonetary(item.equipment)}
                  />
                  <CardTotal
                    label={i18n.wbs.itemOccurrences.labor}
                    value={formatMonetary(item.labor)}
                  />
                  <CardTotal
                    label={i18n.wbs.itemOccurrences.material}
                    value={formatMonetary(item.material)}
                  />
                  <CardTotal
                    label={i18n.wbs.itemOccurrences.others}
                    value={formatMonetary(item.others)}
                  />
                </Grid>
                <CardTotal
                  label={i18n.wbs.itemOccurrences.fields.totalUnit}
                  value={formatMonetary(item.unitCost)}
                  isBold={true}
                />
              </Grid>
              <TableOccurences
                rows={rows}
                onClickLink={this.handleClickRowLink}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                {i18n.wbs.itemOccurrences.return}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(DialogItemOccurrences);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/DialogItemOccurrences/index.tsx